import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBtn from "../../atoms/button/mainBtn";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";

import useDisplay from "../../../hooks/useDisplay";
import { route } from "../../../router/route";
import PCContainer from "../../atoms/layout/pcContainer";
import { fileUrl } from "../../../api/api";

import LSBdDisplay03 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay03";
import LSBdH1HeadLine from "../../molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import ReviewItem from "../../organisms/lecture/reviewItem";
import LSRgDisplay02 from "../../molecules/text/linSeedKr/Rg/lsRgDisplay02";

import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import ReviewSwiper from "../lecture/reviewSwiper";

function DetailTop({
  lectureInfo,
  reviewList,
  setIsLoginCheckModal,
  scrapFunc,
  isScrap,
  reviewClicked,
  consultingCheckFunc,
  isProcessing,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();

  return (
    <>
      <div
        style={{
          width: "100%",
          background: "#EDEDFF80",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isSmall ? "0px" : "60px 0px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: isSmall ? "20px" : "0px 0px 20px 0px",
            }}
          >
            <LSRgH1HeadLine
              onClick={() => {
                navigate(route.home);
              }}
              style={{
                color: "#6F7480",
                fontSize: isSmall ? 12 : 16,
                lineHeight: isSmall ? "14.4px" : "22.4px",
                cursor: "pointer",
              }}
            >
              HOME
            </LSRgH1HeadLine>
            <img
              src="/assets/icons/right_text.svg"
              style={{
                margin: "0px 12px",
                width: isSmall ? 5 : "auto",
                height: isSmall ? 10 : "auto",
              }}
              alt="right_text"
            />
            <LSRgH1HeadLine
              onClick={() => {
                navigate(route.consulting_apply);
              }}
              style={{
                color: "#6F7480",
                fontSize: isSmall ? 12 : 16,
                lineHeight: isSmall ? "14.4px" : "22.4px",
                cursor: "pointer",
              }}
            >
              컨설팅
            </LSRgH1HeadLine>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
            }}
          >
            <div
              style={{
                width: isSmall ? "100%" : 585,
                marginRight: isSmall ? 0 : 30,
              }}
            >
              <img
                src={
                  lectureInfo?.thumbnailServerFileName
                    ? `${fileUrl}/${lectureInfo?.thumbnailServerFileName}`
                    : ""
                }
                style={{
                  height: isSmall ? "auto" : 373,
                  width: isSmall ? "100%" : 585,
                  marginBottom: isSmall ? 0 : 33,
                  borderRadius: isSmall ? 0 : 15,
                }}
                alt="video"
              />
              {isSmall ? null : reviewList.length > 0 ? (
                <ReviewSwiper
                  dataList={reviewList}
                  reviewClicked={reviewClicked}
                />
              ) : null}
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: isSmall ? 20 : 0,
              }}
            >
              <LSBdDisplay03
                style={{
                  color: "#000000",
                  marginTop: isSmall ? 4 : 8,
                  marginBottom: isSmall ? 4 : 8,
                  fontSize: isSmall ? 24 : 32,
                  lineHeight: isSmall ? "33.6px" : "44.8px",
                }}
              >
                {lectureInfo?.title}
              </LSBdDisplay03>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <img
                  style={{
                    width: 16,
                    height: 16,
                    marginRight: 4,
                  }}
                  src={"/assets/icons/star_3d.png"}
                  alt="star_3d"
                />
                <LSRgH1HeadLine
                  style={{
                    color: "#6F7480",
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {lectureInfo?.reviewScore?.toFixed(1)}
                </LSRgH1HeadLine>
                <div
                  style={{
                    height: isSmall ? 12 : 16,
                    width: 1,
                    marginLeft: isSmall ? 14 : 8,
                    marginRight: isSmall ? 14 : 8,
                    background: "#6F7480",
                  }}
                />
                <LSRgH1HeadLine
                  style={{
                    color: "#6F7480",
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {formatNumberWithCommas(lectureInfo?.reviewCount)}개의
                  수강후기
                </LSRgH1HeadLine>
              </div>

              <div
                style={{
                  height: 1,
                  width: "100%",
                  background: "#DBDDE0",
                  marginTop: isSmall ? 16 : 40,
                  marginBottom: isSmall ? 16 : 20,
                }}
              />

              <TopTextContain $isSmall={isSmall}>
                <TopRightText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  강사명
                </TopRightText>
                <TopLeftText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {lectureInfo?.instructorName}
                </TopLeftText>
              </TopTextContain>

              <div style={{ marginTop: isSmall ? 16 : 162 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: isSmall ? 16 : 4,
                    }}
                  >
                    <LSRgH2HeadLine
                      style={{
                        color: "#000000",
                        fontSize: isSmall ? 16 : 18,
                        lineHeight: isSmall ? "22.4px" : "25.2px",
                      }}
                    >
                      총 결제금액
                    </LSRgH2HeadLine>
                    <LSBdDisplay02
                      style={{
                        color: "#101113",
                      }}
                    >
                      {formatNumberWithCommas(lectureInfo?.price)}원
                    </LSBdDisplay02>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: isSmall ? 16 : 33,
                }}
              >
                <div
                  onClick={() => {
                    scrapFunc();
                  }}
                  style={{
                    minWidth: isSmall ? 42 : 73,
                    height: isSmall ? 46 : 60,
                    border: "1px solid #DBDDE0",
                    background: "#fff",
                    cursor: "pointer",
                    borderRadius: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <img
                    src={
                      isScrap
                        ? "/assets/icons/bookmark_a.png"
                        : "/assets/icons/bookmark_d.png"
                    }
                    style={{
                      height: isSmall ? 20 : 32,
                      width: isSmall ? 20 : 32,
                    }}
                    alt="bookmark_d"
                  />
                </div>

                <MainBtn
                  disabled={isProcessing}
                  onClick={() => {
                    if (sessionStorage.getItem("isLogin") === "true") {
                      consultingCheckFunc();
                    } else {
                      setIsLoginCheckModal();
                    }
                  }}
                  style={{
                    marginLeft: isSmall ? 16 : 29,
                    height: isSmall ? 46 : 60,
                  }}
                >
                  <LSRgDisplay02
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                      fontSize: isSmall ? 16 : 24,
                      lineHeight: isSmall ? "22.4px" : "33.6px",
                    }}
                  >
                    {isProcessing ? "처리 중" : "수강하기"}
                  </LSRgDisplay02>
                </MainBtn>
              </div>

              {isSmall ? (
                <OverflowXHidden
                  style={{
                    marginTop: 31,
                  }}
                >
                  {reviewList.map((item, index) => {
                    return (
                      <ReviewItem
                        data={item}
                        key={index}
                        reviewClicked={reviewClicked}
                      />
                    );
                  })}
                </OverflowXHidden>
              ) : null}
            </div>
          </div>
        </PCContainer>
      </div>
    </>
  );
}

export default DetailTop;

const TopTextContain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => (props.$isSmall ? "6px" : "8px")};
`;

const TopRightText = styled(LSBdH1HeadLine)`
  width: 55px;
  margin-right: 18px;
  color: #898e99;
`;

const TopLeftText = styled(LSRgH1HeadLine)`
  color: #000000;
`;

const OverflowXHidden = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-x: auto;
  width: 100%;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
`;
